
import {defineComponent, PropType} from "vue";

export default defineComponent({
  name: "TipInput",
  props: {
    options: {
      required: true,
      type: Object as PropType<Record<string, string>>
    },
    modelValue: {
      type: String,
      required: true,
    }
  },
  data: () => ({
    dropped: false,
    filter: "",
    returnValue: false,
  }),
  computed: {
    filteredOptions() {
      let out: Record<string, string> = {};
      for (let key in this.options) {

        if (this.options[key].toLocaleLowerCase().startsWith(this.filter.toLocaleLowerCase())) {
          out[key] = this.options[key];
        }
      }
      return out;
    }
  },
  methods: {
    showDropdown() {
      this.dropped = true;
    },

    onDocumentClick(e: MouseEvent) {
      if (!e.composedPath().includes(this.$refs.wrapper as EventTarget)) {
        this.hideDropdown();
      }
    },

    hideDropdown() {
      setTimeout(() => {
        this.dropped = false;
        if (this.options && !Object.values(this.options).includes(this.filter)) {
          this.filter = this.options[this.modelValue] || "";
        }
      }, 10)
    },

    select(key: string) {
      this.hideDropdown();

      this.filter = this.options[key];
      let out = key;
      if (this.returnValue) {
        out = this.options[key];
      }
      this.$emit("update:modelValue", out);
      this.$emit("input", out);
    },
  },
  mounted() {
    this.filter = this.modelValue;
    document.addEventListener('mousedown', this.onDocumentClick);
  },
  beforeUnmount() {
    document.removeEventListener('mousedown', this.onDocumentClick)
  }

})
